import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = window.__firebase_config || {
  apiKey: "AIzaSyB1eUpLLcPwcwrWLJAJSLwumJBDmw-XBVY",
  authDomain: "skillvend-prod.firebaseapp.com",
  projectId: "skillvend-prod",
  storageBucket: "skillvend-prod.firebasestorage.app",
  messagingSenderId: "200047871463",
  appId: "1:200047871463:web:245f5ed94fa38f7fe06942",
  measurementId: "G-118PV1NBH5"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'asia-south1');

if (window.location.hostname === 'localhost') {
  window.self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, 'localhost', 9001);
  connectStorageEmulator(storage, 'localhost', 9003);
  connectFunctionsEmulator(functions, 'localhost', 9000);
}

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6Lfu7SQsAAAAAI-vPBEdoX9lIxRzvrFd4qktDXbL'),
  isTokenAutoRefreshEnabled: true
});

export default app;
